function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "37",
  height: "37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 37"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "6",
  y: "5",
  width: "26",
  height: "27",
  rx: "8",
  fill: "#F9F6F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.068 18.58c.012 10.252-8.272 18.541-18.552 18.57C8.33 37.176-.01 28.83 0 18.616a18.56 18.56 0 0 1 11.475-17.14A18.55 18.55 0 0 1 18.58.074C28.75.09 37.057 8.404 37.068 18.581Zm-25.053 1.67-.034.132-1.384.103c.648 1.85 2.087 2.606 3.94 3.03-.331.255-.526.464-.768.584-1.572.782-3.216 1.28-5.004 1.168a2.92 2.92 0 0 0-.34.015c.253.257.55.467.876.62a12.937 12.937 0 0 0 8.27 1.102c4.1-.78 7.092-3.02 8.678-6.96.658-1.646.936-3.378.956-5.148a1.186 1.186 0 0 1 .472-1.006c.485-.403.894-.899 1.325-1.366.09-.099.132-.246.237-.465-.659.132-1.17.436-1.844.41.579-.69 1.186-1.236 1.374-2.146l-.548.215c-.491.188-.985.371-1.473.564-.395.158-.705.108-1.07-.19-1.411-1.146-2.998-1.329-4.621-.536-1.624.793-2.502 2.147-2.518 3.998v.859a15.516 15.516 0 0 1-4.872-1.416c-1.534-.743-2.821-1.812-3.996-3.083a2.823 2.823 0 0 0-.238.333 3.029 3.029 0 0 0-.225.547c-.408 1.607-.066 3.035 1.027 4.285.132.154.28.297.421.443l-.09.146-1.503-.395c-.058.715.132 1.317.415 1.889.526 1.096 1.398 1.829 2.537 2.269Z",
  fill: "#600436"
}));